import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires fbq PageView on client-side route changes. The initial PageView is sent
 * by the base code in public/index.html.
 */
const FacebookPixelPageView = () => {
  const { pathname } = useLocation();
  const prevPathRef = useRef();

  useEffect(() => {
    if (prevPathRef.current === pathname) return;
    const isFirstPaint = prevPathRef.current === undefined;
    prevPathRef.current = pathname;
    if (isFirstPaint) return;
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [pathname]);

  return null;
};

export default FacebookPixelPageView;
